@import 'styles/mixins';
@import 'styles/variables';

.logo {
  animation-name: pulse;
  animation-duration: 1s;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
  animation-iteration-count: infinite;

  @keyframes pulse {
    0% {
      fill: $gray-20;
    }
    100% {
      fill: $almanac-black;
    }
  }

  @-webkit-keyframes pulse {
    0% {
      fill: $gray-20;
    }
    100% {
      fill: $almanac-black;
    }
  }
}
